import { plainToClassFromExist } from 'class-transformer';

export default class ModelMapperService {
  static autoMapperMapAnythingFromAPI<T> (response: T, json: any): T {
    const _response = plainToClassFromExist(response, json);
    return _response;
  }
}